module.exports = __webpack_public_path__ + "img/181F1F_475057_616566_525C62-256px.d02706b4.png";